import { gql } from '@apollo/client';
export const EXPORT_COMPETENCE_ORDERS = gql`
  mutation ExportCompetenceOrders($input: CompetenceOrdersFilterMutationExportInput) {
    exportCompetenceOrders(input: $input) {
      fileId
      fileName
      filePath
      fileBytes
    }
  }
`;

export const COMPETENCE_ORDERS_LIST_DELETE = gql`
  mutation competenceOrderDelete($input: CompetenceOrderDelete) {
    competenceOrderDelete(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const COMPETENCE_ORDERS_SAVE = gql`
  mutation competenceOrderSave($input: CompetenceOrderMutation) {
    competenceOrderSave(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const COMPETENCE_ORDERS_RULE_SAVE = gql`
  mutation competenceOrderRuleSave($input: CompetenceOrderRuleMutation) {
    competenceOrderRuleSave(input: $input) {
      approvalTypeLevelId
      approvalTypeLevelSiteId
      competenceOrderId
      competenceOrderRuleId
      decisionFormula
      expression
      isSystem
      levelName
      orderId
      ruleStatusCode
      ruleStatusId
      ruleStatusName
      siteId
    }
  }
`;

export const COMPETENCE_ORDERS_RULE_DELETE = gql`
  mutation competenceOrderRuleDelete($input: CompetenceOrderRuleDelete) {
    competenceOrderRuleDelete(input: $input) {
      commandId
      correlationId
    }
  }
`;
